import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'Constants/env';
import { ContactModelV2, IContact } from 'Models/ContactModelV2';
import { isNullOrUndefined } from 'util';
import API from '~/api';
import { useConversationStore } from '../index.store';

export const QUERY_KEY_FETCH_PERSON_BY_PERSON_ID =
  'conversation.fetchPersonByPersonId';

const fetchMentionUsers = async (
  personIds: string[]
): Promise<Map<string, ContactModelV2>> => {
  if (isNullOrUndefined(personIds) || personIds.length === 0) {
    return useConversationStore.getState().mentionUsers;
  }

  const fetchPromises = personIds.map(async (personId) => {
    const { data } = await API.get<IContact>(
      API_ENDPOINTS.MatchContactBySource(),
      { params: { sourcePlatform: 'Bhive', sourceId: personId } }
    );

    useConversationStore
      .getState()
      .addMentionUser(ContactModelV2.fromResponseDto(data));
  });

  await Promise.all(fetchPromises);

  return useConversationStore.getState().mentionUsers;
};

export const useFetchMentionUsers = (personIds: string[]) =>
  useQuery({
    queryKey: [QUERY_KEY_FETCH_PERSON_BY_PERSON_ID, personIds],
    queryFn: async () => fetchMentionUsers(personIds),
  });
